import React from "react";

const Button = ({ children, variant, size, onClick, custom }) => {
  const baseClasses = "font-medium leading-6";

  const variantClasses = {
    primary: "text-white bg-rose-700",
    outline: "text-rose-700 border border-rose-700 border-solid",
    disabled: "text-white bg-rose-200",
  };

  const sizeClasses = {
    small: "px-4 py-1.5 text-sm",
    large: "px-6 py-3 w-full text-base h-[50px] max-sm:h-11",
  };

  return (
    <button
      type="button"
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${custom}`}
      onClick={onClick}
      disabled={variant === "disabled"}
    >
      {children}
    </button>
  );
};

export default Button;
